import script from "./UserListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserListPage.vue?vue&type=script&setup=true&lang=js"

import "./UserListPage.vue?vue&type=style&index=0&id=66180e4a&lang=css"

const __exports__ = script;

export default __exports__